var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.892578,
    y: 0.643326,
    width: 47.7429,
    height: 47.7429,
    rx: 3.97858,
    fill: "#FEF0EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_667_20024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 32,
    height: 33
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8.18825,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_667_20024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7443 34.1882C14.0708 34.1882 13.5007 33.9549 13.034 33.4882C12.5673 33.0216 12.334 32.4515 12.334 31.7779V16.5986C12.334 15.925 12.5673 15.3549 13.034 14.8882C13.5007 14.4216 14.0708 14.1882 14.7443 14.1882H35.257C35.9305 14.1882 36.5007 14.4216 36.9673 14.8882C37.434 15.3549 37.6673 15.925 37.6673 16.5986V31.7779C37.6673 32.4515 37.434 33.0216 36.9673 33.4882C36.5007 33.9549 35.9305 34.1882 35.257 34.1882H14.7443ZM25.0007 24.9319L35.6673 18.1112L35.4623 16.1882L25.0007 22.8549L14.539 16.1882L14.334 18.1112L25.0007 24.9319Z",
    fill: "#F46530"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCon);
export default __webpack_public_path__ + "static/media/email-con.82141a13c97da7be26693cfae64cd28d.svg";
export { ForwardRef as ReactComponent };